import {
  AboutYou,
  AboutYouValidate,
  AboutYouValues,
  ContactLink,
  ContactLinkValidate,
  ContactLinkValues,
  ContentStrengths,
  ContentStrengthsValidate,
  ContentStrengthsValues,
  Experience,
  ExperienceValidate,
  ExperienceValues,
  NameAndPlatform,
  NameAndPlatformValidate,
  NameAndPlatformValues,
  ThemesAndAffinities,
  ThemesAndAffinitiesValidate,
  ThemesAndAffinitiesValues,
} from '~/components/MediaPackSteps';
import { StepperFormStepType } from '~/components/StepperForm/StepperForm.types';
import { getMainPlatformData } from '~/creatorUtils';
import { CreatorType, DefaultMediaPackType } from '~/types';

interface Props {
  creator: CreatorType;
  mediaPack: DefaultMediaPackType;
  onSubmit: (params: Partial<DefaultMediaPackType>) => Promise<void>;
}

export const STEPS = ({
  creator,
  mediaPack,
  onSubmit,
}: Props): StepperFormStepType[] => {
  const { handle, name } = getMainPlatformData(creator);

  const nameAndPlatformStep: StepperFormStepType<NameAndPlatformValues> = {
    component: NameAndPlatform,
    initialValues: {
      name: mediaPack.name || '',
      platforms: mediaPack.platforms || [],
    },
    onValidate: NameAndPlatformValidate,
    onSubmit,
    required: true,
    title: 'Name & Platforms',
  };
  const aboutYouStep: StepperFormStepType<AboutYouValues> = {
    component: AboutYou,
    initialValues: {
      aboutMeName: mediaPack.aboutMeName || name || handle || '',
      aboutMeDescription: mediaPack.aboutMeDescription || '',
    },
    onValidate: AboutYouValidate,
    onSubmit,
    required: true,
    title: 'About you',
  };
  const themesAndAffinitiesStep: StepperFormStepType<ThemesAndAffinitiesValues> =
    {
      component: ThemesAndAffinities,
      initialValues: {
        themesAndAffinities: mediaPack.themesAndAffinities || [],
      },
      onValidate: ThemesAndAffinitiesValidate,
      onSubmit,
      required: true,
      title: 'Themes & Affinities',
    };
  const contentStrengthsStep: StepperFormStepType<ContentStrengthsValues> = {
    component: ContentStrengths,
    onValidate: ContentStrengthsValidate,
    onSubmit,
    initialValues: { contentStrengths: mediaPack.contentStrengths || [] },
    required: true,
    title: 'Content strengths',
  };
  const experienceStep: StepperFormStepType<ExperienceValues> = {
    component: Experience,
    onValidate: ExperienceValidate,
    onSubmit,
    initialValues: { experienceTags: mediaPack.experienceTags || [] },
    title: 'Experience',
  };
  const contactLinkStep: StepperFormStepType<ContactLinkValues> = {
    component: ContactLink,
    onValidate: ContactLinkValidate,
    onSubmit,
    initialValues: {
      email: mediaPack.email || creator.manager?.email || creator.email || '',
    },
    required: true,
    title: 'Contact link',
  };

  return [
    nameAndPlatformStep,
    aboutYouStep,
    themesAndAffinitiesStep,
    contentStrengthsStep,
    experienceStep,
    contactLinkStep,
  ];
};
